import {
  BreakpointsEnum,
  RewardsEntry,
  isBreakpointDown,
  useBreakpoint,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {HStack, Text, View} from 'native-base';
import React, {useState} from 'react';

import PaginationBar from 'components/PaginationBar';

import {CreditsTab} from '.';
import TYPE_DISPLAY from './typeDisplay';

export interface CreditsTableProps {
  selectedTab: CreditsTab;
  rewardsList: RewardsEntry[] | undefined;
}

export const ITEMS_PER_PAGE = 10;

const CreditsTable = (props: CreditsTableProps) => {
  const {selectedTab, rewardsList = []} = props;
  const [currentPage, setCurrentPage] = useState(1);
  const isDesktop = useIsDesktop();
  const isSmallScreen = isBreakpointDown(
    useBreakpoint(),
    BreakpointsEnum.MICRO
  );
  const isRedeemed = selectedTab === CreditsTab?.redeemed;
  const paddingX = isDesktop ? '32px' : '16px';
  const numPages = Math.ceil(rewardsList?.length / ITEMS_PER_PAGE);
  const currentItems = rewardsList.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const renderItems = currentItems.map((item, i) => {
    const isWhiteBg = i % 2 === 0;
    const lastChildBbr = i === currentItems.length - 1 ? '8px' : undefined;

    return (
      <HStack
        py="16px"
        bgColor={isWhiteBg ? 'white' : 'athens'}
        paddingX={paddingX}
        key={`credit-table-${i}`}
        px={paddingX}
        justifyContent="space-between"
        borderBottomRadius={lastChildBbr}>
        <HStack>
          <Text
            maxW={isSmallScreen ? '150px' : undefined}
            minW="75px"
            fontSize="12px"
            lineHeight="13px">
            {isRedeemed ? item.date : TYPE_DISPLAY[item.type]}
          </Text>
          {isRedeemed && (
            <Text
              marginLeft={isDesktop ? '64px' : '24px'}
              fontSize="12px"
              lineHeight="13px">
              {item.type}
            </Text>
          )}
        </HStack>
        <Text fontSize="12px" lineHeight="13px">
          {item.amount}
        </Text>
      </HStack>
    );
  });

  if (!rewardsList || !rewardsList.length) {
    return <Text>No transactions for this month.</Text>;
  }

  return (
    <View
      borderRadius="8px"
      borderWidth="1px"
      borderColor="rgba(112,119,132,0.3)">
      <HStack
        py="16px"
        borderTopRadius="8px"
        px={paddingX}
        bgColor="athens"
        justifyContent="space-between">
        <HStack>
          <Text
            flexShrink={1}
            minW="75px"
            fontSize="12px"
            lineHeight="13px"
            bold>
            {isRedeemed ? 'Date' : 'Description'}
          </Text>
          {isRedeemed && (
            <Text
              flexShrink={1}
              marginLeft={isDesktop ? '64px' : '24px'}
              fontSize="12px"
              lineHeight="13px"
              bold>
              Credits{isDesktop ? ' ' : '\n'}Type
            </Text>
          )}
        </HStack>
        <View>
          <Text fontSize="12px" lineHeight="13px" bold>
            Rewards{isDesktop ? ' ' : '\n'}Credits
          </Text>
        </View>
      </HStack>
      <View>{renderItems}</View>
      {numPages > 1 && (
        <View
          alignItems="center"
          borderBottomRadius="8px"
          bgColor="white"
          w="100%"
          py={isDesktop ? '24px' : '32px'}>
          <PaginationBar
            shouldScrollToTop={false}
            isFullWidth={!isDesktop}
            onPageChange={setCurrentPage}
            numPages={numPages}
          />
        </View>
      )}
    </View>
  );
};

export default CreditsTable;
